import React from 'react';
import PropTypes from 'prop-types';

import { Show } from '../../show';

import { getCdesCorrection, isExerciseWithCdes } from '../../../lib/checker';

import { Question } from '../../exercise/components';
import CdeFeedback from '../../feedback/checker/cde-feedback';
import RadioFeedback from '../../feedback/checker/radio-feedback';
import StepsFeeedback from '../../feedback/checker/steps-feedback';
import FluidContainer from '../../layouts/components/fluid-container';
import ExistenceConditions from '../../exercise/checker/existence-conditions';
import Spacer from '../../spacer';
import Execution from '../../exercise/checker/execution';
import { MISSING, CORRECT } from '../../../lib/exercise';
import Stack from '../../stack';

const CheckerCorrection = ({ exercise, answers = {}, correctionStatus }) => {
    const selectedAnswer = answers.answer || {};

    const { cdes = [], steps = [] } = selectedAnswer;

    const hasCdes = isExerciseWithCdes(exercise);
    const cdeCorrection = getCdesCorrection(cdes);
    return (
        <FluidContainer flexDirection="column" marginLeft={['none', 'tablet', 'desktop']}>
            <Show when={exercise.prompt}>
                <FluidContainer paddingBottom={24}>{exercise.prompt}</FluidContainer>
            </Show>
            <Stack gap="small">
                <Question>{exercise.question}</Question>
                <Show when={hasCdes}>
                    <CdeFeedback exercise={exercise} answers={selectedAnswer}>
                        <Show when={cdeCorrection !== MISSING}>
                            <ExistenceConditions cdes={cdes} correctionStatus={correctionStatus} exercise={exercise} isCorrectable={true} />
                        </Show>
                    </CdeFeedback>
                </Show>

                <Show when={correctionStatus?.state !== MISSING || correctionStatus?.status !== MISSING}>
                    <Execution exercise={exercise} correctionStatus={correctionStatus} correctable={true} steps={steps} />
                </Show>
                <Show when={correctionStatus?.state !== CORRECT || correctionStatus?.status !== CORRECT}>
                    <StepsFeeedback exercise={exercise} correctionStatus={correctionStatus} steps={steps} />
                </Show>
            </Stack>
            <Spacer size="regular" />
            <RadioFeedback exercise={exercise} answers={selectedAnswer} correctionStatus={correctionStatus} />
        </FluidContainer>
    );
};

CheckerCorrection.propTypes = {
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    exercise: PropTypes.object,
    correctionStatus: PropTypes.object,
};

export default CheckerCorrection;
